import React from "react";

import Hero from "../components/Hero/Hero";
import Leaderboard from "../components/Leaderboard/Leaderboard";

const HomePage = () => {
  return (
    <>
      <Hero />
      <Leaderboard />
    </>
  );
};

export default HomePage;
